"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catalanDocs = void 0;
var catalanDocs = {
  name: 'catalan',
  category: 'Combinatorics',
  syntax: ['catalan(n)'],
  description: 'The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.',
  examples: ['catalan(3)', 'catalan(8)'],
  seealso: ['bellNumbers']
};
exports.catalanDocs = catalanDocs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/cjs/expression/embeddedDocs/function/combinatorics/catalan.js
// module id = XGTn
// module chunks = 23